import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/20/solid';

import { Drawer } from '@/components/ui/daisy';

type DesktopWrapperProps = PropsWithChildren<{
  isOpen: boolean;
  onClose(): void;
}>;

export default function DesktopWrapper({
  isOpen,
  onClose,
  children,
}: DesktopWrapperProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentDashboard.courseSelect',
  });

  const handleOpenChange = (open: boolean) => {
    if (!open) onClose();
  };

  return (
    <Drawer
      open={isOpen}
      onOpenChange={handleOpenChange}
      position="end"
      className="absolute"
    >
      <Drawer.Content />
      <Drawer.Side
        className="z-[499]"
        components={{
          overlay: { className: 'bg-transparent', 'aria-label': t('close') },
        }}
      >
        <div className="flex min-h-full w-[390px] flex-col gap-4 border border-base-100 bg-base-200/90 p-4 backdrop-blur">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold text-base-content">
              {t('selectCourse')}
            </h3>
            <Drawer.Close aria-label={t('close')} className="btn-sm">
              <XMarkIcon className="size-6" />
            </Drawer.Close>
          </div>
          {children}
        </div>
      </Drawer.Side>
    </Drawer>
  );
}
